package aexorsa

import react.create
import react.dom.client.createRoot
import tanstack.react.router.RouterProvider
import web.dom.ElementId
import web.dom.document

fun main() {
    val container = document.getElementById(ElementId("root"))
        ?: error("Missing #root mount element")
    val appRouter = createAppRouter()

    createRoot(container).render(
        RouterProvider.create {
            router = appRouter
        },
    )
}
